import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  getListAccountingTypesQueryKey,
  type UpdateAccountingTypeMutationError,
  useUpdateAccountingType,
} from '@/entities/masters/api/generated/api';
import { toast } from '@/shared/ui';

export const useAccountingTypesEditMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useUpdateAccountingType({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(
          t('common.messages.update-success', {
            name: t('master-management.menu.accounting-types'),
          }),
        );
        queryClient.invalidateQueries({
          queryKey: getListAccountingTypesQueryKey(),
        });
        onSuccess();
      },
      onError: (error: UpdateAccountingTypeMutationError) => {
        if (error.response?.data.error_code === 'VALIDATION_ERROR') {
          toast.error(t('master-management.accounting-types.create.error.duplicate-code'));
          return;
        }
        toast.error(
          t('common.messages.update-failed', {
            name: t('master-management.menu.accounting-types'),
          }),
        );
      },
    },
  });
};
